import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=ca003654"
import script from "./RightSideBar.vue?vue&type=script&lang=js"
export * from "./RightSideBar.vue?vue&type=script&lang=js"
import style0 from "./RightSideBar.vue?vue&type=style&index=0&id=ca003654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports